/* eslint-disable */
/* GENERATED FILE DO NOT EDIT */
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type ApiKeyCredentials = {
  apiKey: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyCredentialsUpdateInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
};

export type ClientSecretCredentials = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type ClientSecretCredentialsUpdateInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFeedInput = {
  api_key_credentials?: InputMaybe<ApiKeyCredentials>;
  client_secret_credentials?: InputMaybe<ClientSecretCredentials>;
  dataSourceType?: InputMaybe<Scalars['Int']['input']>;
  groupAssignments?: InputMaybe<Array<GroupAssignmentInput>>;
  integrationKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password_credentials?: InputMaybe<PasswordCredentials>;
  refresh_token_credentials?: InputMaybe<RefreshTokenCredentials>;
  vendorId: Scalars['Int']['input'];
  verifyCredentials?: InputMaybe<Scalars['Boolean']['input']>;
  /** AEMP version. Defaults to 2 for V2. */
  versionId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateFeedResult = {
  __typename: 'CreateFeedResult';
  error?: Maybe<GenericError>;
  feedId?: Maybe<Scalars['String']['output']>;
};

export type DeleteFeedInput = {
  feedId: Scalars['String']['input'];
};

export type FeedResult = {
  __typename: 'FeedResult';
  /** Display Text when rendering the Call To Action URL Button */
  callToActionText?: Maybe<Scalars['String']['output']>;
  /** URL that has the Call To Action Link */
  callToActionUrl?: Maybe<Scalars['String']['output']>;
  currentStatus?: Maybe<Scalars['Int']['output']>;
  feedId: Scalars['String']['output'];
  integration?: Maybe<IntegrationForFeed>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastUpdate?: Maybe<Scalars['String']['output']>;
  /**
   * The update interval in minutes for the feed.
   * @deprecated Use the refreshIntervalMinutes field in the integration object instead.
   */
  minuteInterval?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nextUpdate?: Maybe<Scalars['String']['output']>;
};

export type FeedSearchResults = {
  __typename: 'FeedSearchResults';
  error?: Maybe<Scalars['String']['output']>;
  feeds?: Maybe<Array<FeedResult>>;
  lastPaginatedFeedId?: Maybe<Scalars['String']['output']>;
};

export type GenericError = {
  __typename: 'GenericError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GetFeedResult = {
  __typename: 'GetFeedResult';
  error?: Maybe<Scalars['String']['output']>;
  feed?: Maybe<FeedResult>;
};

export type GroupAssignmentInput = {
  effectiveEndTime?: InputMaybe<Scalars['String']['input']>;
  effectiveStartTime: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
};

export type HelpUrl = {
  __typename: 'HelpUrl';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Integration = {
  __typename: 'Integration';
  authType: Scalars['String']['output'];
  description: Scalars['String']['output'];
  helpUrls: Array<HelpUrl>;
  id: Scalars['String']['output'];
  isAEMPV2: Scalars['Boolean']['output'];
  /** Indicates if the integration is active and should be displayed to the user. */
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** URL to the OEM's logo for the integration. */
  oemLogoUrl?: Maybe<Scalars['String']['output']>;
  /** The frequency in minutes that the feed should be updated. */
  refreshIntervalMinutes?: Maybe<Scalars['Int']['output']>;
  requiredFields: Array<RequiredFieldResult>;
  selfServiceSupported: Scalars['Boolean']['output'];
  /** Indicates if the integration has Post Authentication Steps. */
  supportsPostAuth: Scalars['Boolean']['output'];
  vendorId: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type IntegrationForFeed = {
  __typename: 'IntegrationForFeed';
  authType: Scalars['String']['output'];
  description: Scalars['String']['output'];
  helpUrls: Array<HelpUrl>;
  id: Scalars['String']['output'];
  isAEMPV2: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** URL to the OEM's logo for the integration. */
  oemLogoUrl?: Maybe<Scalars['String']['output']>;
  /** The frequency in minutes that the feed should be updated. */
  refreshIntervalMinutes?: Maybe<Scalars['Int']['output']>;
  requiredFields: Array<RequiredFieldWithValue>;
  selfServiceSupported: Scalars['Boolean']['output'];
  supportsPostAuth: Scalars['Boolean']['output'];
  vendorId: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** Create a new Feed for the user's company */
  createFeedMutation?: Maybe<CreateFeedResult>;
  /** Delete an existing feed. */
  deleteFeed?: Maybe<UpdateFeedResult>;
  /** Get the OAuth URL for a specific feed integration. If you want a Milwaukee OAuth URL, use 'milwaukee' as the feedId. */
  feedOAuthURL: Scalars['String']['output'];
  /** Update an existing feed */
  updateFeed?: Maybe<UpdateFeedResult>;
};


export type MutationCreateFeedMutationArgs = {
  input: CreateFeedInput;
};


export type MutationDeleteFeedArgs = {
  input: DeleteFeedInput;
};


export type MutationFeedOAuthUrlArgs = {
  feedId: Scalars['String']['input'];
};


export type MutationUpdateFeedArgs = {
  input: UpdateFeedInput;
};

export type PasswordCredentials = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type PasswordCredentialsUpdateInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename: 'Query';
  feed?: Maybe<GetFeedResult>;
  integration?: Maybe<Integration>;
  integrations: Array<Integration>;
  searchFeeds?: Maybe<FeedSearchResults>;
};


export type QueryFeedArgs = {
  id: Scalars['String']['input'];
};


export type QueryIntegrationArgs = {
  id: Scalars['String']['input'];
};


export type QuerySearchFeedsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastPaginatedFeedId?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
};

export type RefreshTokenCredentials = {
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  refreshToken: Scalars['String']['input'];
};

export type RefreshTokenCredentialsUpdateInput = {
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type RequiredFieldResult = {
  __typename: 'RequiredFieldResult';
  credentialType: Scalars['String']['output'];
  description: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  protected: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
};

export type RequiredFieldWithValue = {
  __typename: 'RequiredFieldWithValue';
  credentialType: Scalars['String']['output'];
  currentValue?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  protected: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
};

export type UpdateFeedInput = {
  api_key_credentials?: InputMaybe<ApiKeyCredentialsUpdateInput>;
  client_secret_credentials?: InputMaybe<ClientSecretCredentialsUpdateInput>;
  feedId: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password_credentials?: InputMaybe<PasswordCredentialsUpdateInput>;
  refresh_token_credentials?: InputMaybe<RefreshTokenCredentialsUpdateInput>;
  verifyCredentials?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFeedResult = {
  __typename: 'UpdateFeedResult';
  error?: Maybe<GenericError>;
  success: Scalars['Boolean']['output'];
};

export type AvailableIntegrationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AvailableIntegrationQuery = { __typename: 'Query', integration?: { __typename: 'Integration', authType: string, description: string, id: string, isAEMPV2: boolean, name: string, vendorId: number, selfServiceSupported: boolean, supportsPostAuth: boolean, versionId: number, requiredFields: Array<{ __typename: 'RequiredFieldResult', fieldName: string, description: string, protected: boolean, required: boolean, fieldType: string, credentialType: string }>, helpUrls: Array<{ __typename: 'HelpUrl', key: string, value: string, description: string }> } | null };

export type AvailableIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableIntegrationsQuery = { __typename: 'Query', integrations: Array<{ __typename: 'Integration', authType: string, description: string, id: string, isAEMPV2: boolean, name: string, oemLogoUrl?: string | null, selfServiceSupported: boolean, supportsPostAuth: boolean, vendorId: number, versionId: number, isActive: boolean, requiredFields: Array<{ __typename: 'RequiredFieldResult', fieldName: string, description: string, protected: boolean, required: boolean, fieldType: string, credentialType: string }>, helpUrls: Array<{ __typename: 'HelpUrl', key: string, value: string, description: string }> }> };

export type CreateFeedMutationVariables = Exact<{
  input: CreateFeedInput;
}>;


export type CreateFeedMutation = { __typename: 'Mutation', createFeedMutation?: { __typename: 'CreateFeedResult', feedId?: string | null, error?: { __typename: 'GenericError', message: string, type: string } | null } | null };

export type GetFeedQueryVariables = Exact<{
  feedId: Scalars['String']['input'];
}>;


export type GetFeedQuery = { __typename: 'Query', feed?: { __typename: 'GetFeedResult', error?: string | null, feed?: { __typename: 'FeedResult', feedId: string, name: string, lastUpdate?: string | null, nextUpdate?: string | null, currentStatus?: number | null, isActive?: boolean | null, callToActionText?: string | null, callToActionUrl?: string | null, integration?: { __typename: 'IntegrationForFeed', id: string, name: string, oemLogoUrl?: string | null, supportsPostAuth: boolean, authType: string, refreshIntervalMinutes?: number | null, helpUrls: Array<{ __typename: 'HelpUrl', key: string, value: string, description: string }>, requiredFields: Array<{ __typename: 'RequiredFieldWithValue', credentialType: string, description: string, fieldName: string, fieldType: string, protected: boolean, required: boolean, currentValue?: string | null }> } | null } | null } | null };

export type SearchFeedsQueryVariables = Exact<{
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastPaginatedFeedId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type SearchFeedsQuery = { __typename: 'Query', searchFeeds?: { __typename: 'FeedSearchResults', error?: string | null, lastPaginatedFeedId?: string | null, feeds?: Array<{ __typename: 'FeedResult', feedId: string, name: string, lastUpdate?: string | null, nextUpdate?: string | null, currentStatus?: number | null, isActive?: boolean | null, integration?: { __typename: 'IntegrationForFeed', name: string, oemLogoUrl?: string | null, supportsPostAuth: boolean, authType: string, refreshIntervalMinutes?: number | null, helpUrls: Array<{ __typename: 'HelpUrl', key: string, value: string, description: string }> } | null }> | null } | null };

export type FetchFeedOAuthUrlMutationVariables = Exact<{
  feedId: Scalars['String']['input'];
}>;


export type FetchFeedOAuthUrlMutation = { __typename: 'Mutation', feedOAuthURL: string };

export type UpdateFeedMutationVariables = Exact<{
  input: UpdateFeedInput;
}>;


export type UpdateFeedMutation = { __typename: 'Mutation', updateFeed?: { __typename: 'UpdateFeedResult', success: boolean, error?: { __typename: 'GenericError', message: string, type: string } | null } | null };



export const AvailableIntegrationDocument = `
    query AvailableIntegration($id: String!) {
  integration(id: $id) {
    authType
    description
    id
    isAEMPV2
    name
    vendorId
    requiredFields {
      fieldName
      description
      protected
      required
      fieldType
      credentialType
    }
    selfServiceSupported
    supportsPostAuth
    helpUrls {
      key
      value
      description
    }
    vendorId
    versionId
  }
}
    `;

export const useAvailableIntegrationQuery = <
      TData = AvailableIntegrationQuery,
      TError = unknown
    >(
      variables: AvailableIntegrationQueryVariables,
      options?: UseQueryOptions<AvailableIntegrationQuery, TError, TData>
    ) => {
    
    return useQuery<AvailableIntegrationQuery, TError, TData>(
      ['AvailableIntegration', variables],
      fetcher<AvailableIntegrationQuery, AvailableIntegrationQueryVariables>(AvailableIntegrationDocument, variables),
      options
    )};

useAvailableIntegrationQuery.getKey = (variables: AvailableIntegrationQueryVariables) => ['AvailableIntegration', variables];

export const useInfiniteAvailableIntegrationQuery = <
      TData = AvailableIntegrationQuery,
      TError = unknown
    >(
      variables: AvailableIntegrationQueryVariables,
      options?: UseInfiniteQueryOptions<AvailableIntegrationQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<AvailableIntegrationQuery, TError, TData>(
      ['AvailableIntegration.infinite', variables],
      (metaData) => fetcher<AvailableIntegrationQuery, AvailableIntegrationQueryVariables>(AvailableIntegrationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

useInfiniteAvailableIntegrationQuery.getKey = (variables: AvailableIntegrationQueryVariables) => ['AvailableIntegration.infinite', variables];

export const AvailableIntegrationsDocument = `
    query AvailableIntegrations {
  integrations {
    authType
    description
    id
    isAEMPV2
    name
    oemLogoUrl
    requiredFields {
      fieldName
      description
      protected
      required
      fieldType
      credentialType
    }
    selfServiceSupported
    supportsPostAuth
    helpUrls {
      key
      value
      description
    }
    vendorId
    versionId
    isActive
  }
}
    `;

export const useAvailableIntegrationsQuery = <
      TData = AvailableIntegrationsQuery,
      TError = unknown
    >(
      variables?: AvailableIntegrationsQueryVariables,
      options?: UseQueryOptions<AvailableIntegrationsQuery, TError, TData>
    ) => {
    
    return useQuery<AvailableIntegrationsQuery, TError, TData>(
      variables === undefined ? ['AvailableIntegrations'] : ['AvailableIntegrations', variables],
      fetcher<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, variables),
      options
    )};

useAvailableIntegrationsQuery.getKey = (variables?: AvailableIntegrationsQueryVariables) => variables === undefined ? ['AvailableIntegrations'] : ['AvailableIntegrations', variables];

export const useInfiniteAvailableIntegrationsQuery = <
      TData = AvailableIntegrationsQuery,
      TError = unknown
    >(
      variables?: AvailableIntegrationsQueryVariables,
      options?: UseInfiniteQueryOptions<AvailableIntegrationsQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<AvailableIntegrationsQuery, TError, TData>(
      variables === undefined ? ['AvailableIntegrations.infinite'] : ['AvailableIntegrations.infinite', variables],
      (metaData) => fetcher<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

useInfiniteAvailableIntegrationsQuery.getKey = (variables?: AvailableIntegrationsQueryVariables) => variables === undefined ? ['AvailableIntegrations.infinite'] : ['AvailableIntegrations.infinite', variables];

export const CreateFeedDocument = `
    mutation CreateFeed($input: CreateFeedInput!) {
  createFeedMutation(input: $input) {
    feedId
    error {
      message
      type
    }
  }
}
    `;

export const useCreateFeedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFeedMutation, TError, CreateFeedMutationVariables, TContext>) => {
    
    return useMutation<CreateFeedMutation, TError, CreateFeedMutationVariables, TContext>(
      ['CreateFeed'],
      (variables?: CreateFeedMutationVariables) => fetcher<CreateFeedMutation, CreateFeedMutationVariables>(CreateFeedDocument, variables)(),
      options
    )};

export const GetFeedDocument = `
    query getFeed($feedId: String!) {
  feed(id: $feedId) {
    feed {
      feedId
      name
      lastUpdate
      nextUpdate
      currentStatus
      isActive
      callToActionText
      callToActionUrl
      integration {
        id
        name
        oemLogoUrl
        supportsPostAuth
        helpUrls {
          key
          value
          description
        }
        requiredFields {
          credentialType
          description
          fieldName
          fieldType
          protected
          required
          currentValue
        }
        authType
        refreshIntervalMinutes
      }
    }
    error
  }
}
    `;

export const useGetFeedQuery = <
      TData = GetFeedQuery,
      TError = unknown
    >(
      variables: GetFeedQueryVariables,
      options?: UseQueryOptions<GetFeedQuery, TError, TData>
    ) => {
    
    return useQuery<GetFeedQuery, TError, TData>(
      ['getFeed', variables],
      fetcher<GetFeedQuery, GetFeedQueryVariables>(GetFeedDocument, variables),
      options
    )};

useGetFeedQuery.getKey = (variables: GetFeedQueryVariables) => ['getFeed', variables];

export const useInfiniteGetFeedQuery = <
      TData = GetFeedQuery,
      TError = unknown
    >(
      variables: GetFeedQueryVariables,
      options?: UseInfiniteQueryOptions<GetFeedQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<GetFeedQuery, TError, TData>(
      ['getFeed.infinite', variables],
      (metaData) => fetcher<GetFeedQuery, GetFeedQueryVariables>(GetFeedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

useInfiniteGetFeedQuery.getKey = (variables: GetFeedQueryVariables) => ['getFeed.infinite', variables];

export const SearchFeedsDocument = `
    query SearchFeeds($isActive: Boolean, $lastPaginatedFeedId: String, $limit: Int!) {
  searchFeeds(
    isActive: $isActive
    lastPaginatedFeedId: $lastPaginatedFeedId
    limit: $limit
  ) {
    feeds {
      feedId
      name
      lastUpdate
      nextUpdate
      currentStatus
      isActive
      integration {
        name
        oemLogoUrl
        supportsPostAuth
        helpUrls {
          key
          value
          description
        }
        authType
        refreshIntervalMinutes
      }
    }
    error
    lastPaginatedFeedId
  }
}
    `;

export const useSearchFeedsQuery = <
      TData = SearchFeedsQuery,
      TError = unknown
    >(
      variables: SearchFeedsQueryVariables,
      options?: UseQueryOptions<SearchFeedsQuery, TError, TData>
    ) => {
    
    return useQuery<SearchFeedsQuery, TError, TData>(
      ['SearchFeeds', variables],
      fetcher<SearchFeedsQuery, SearchFeedsQueryVariables>(SearchFeedsDocument, variables),
      options
    )};

useSearchFeedsQuery.getKey = (variables: SearchFeedsQueryVariables) => ['SearchFeeds', variables];

export const useInfiniteSearchFeedsQuery = <
      TData = SearchFeedsQuery,
      TError = unknown
    >(
      variables: SearchFeedsQueryVariables,
      options?: UseInfiniteQueryOptions<SearchFeedsQuery, TError, TData>
    ) => {
    
    return useInfiniteQuery<SearchFeedsQuery, TError, TData>(
      ['SearchFeeds.infinite', variables],
      (metaData) => fetcher<SearchFeedsQuery, SearchFeedsQueryVariables>(SearchFeedsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

useInfiniteSearchFeedsQuery.getKey = (variables: SearchFeedsQueryVariables) => ['SearchFeeds.infinite', variables];

export const FetchFeedOAuthUrlDocument = `
    mutation FetchFeedOAuthURL($feedId: String!) {
  feedOAuthURL(feedId: $feedId)
}
    `;

export const useFetchFeedOAuthUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FetchFeedOAuthUrlMutation, TError, FetchFeedOAuthUrlMutationVariables, TContext>) => {
    
    return useMutation<FetchFeedOAuthUrlMutation, TError, FetchFeedOAuthUrlMutationVariables, TContext>(
      ['FetchFeedOAuthURL'],
      (variables?: FetchFeedOAuthUrlMutationVariables) => fetcher<FetchFeedOAuthUrlMutation, FetchFeedOAuthUrlMutationVariables>(FetchFeedOAuthUrlDocument, variables)(),
      options
    )};

export const UpdateFeedDocument = `
    mutation UpdateFeed($input: UpdateFeedInput!) {
  updateFeed(input: $input) {
    success
    error {
      message
      type
    }
  }
}
    `;

export const useUpdateFeedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFeedMutation, TError, UpdateFeedMutationVariables, TContext>) => {
    
    return useMutation<UpdateFeedMutation, TError, UpdateFeedMutationVariables, TContext>(
      ['UpdateFeed'],
      (variables?: UpdateFeedMutationVariables) => fetcher<UpdateFeedMutation, UpdateFeedMutationVariables>(UpdateFeedDocument, variables)(),
      options
    )};
